import axios from "axios";
import AsyncStorage from "./components/AsyncStorage";
import R14ApiSubscription from "./R14ApiSubscription";
import R14ApiResult from "./R14ApiResult";

export default class R14Api {
  constructor(R14, app, options) {
    if (!options.config || !options.config.api)
      throw "Api Error: No default config options found.";
    if (!options.config.api.url)
      throw "Api Error: No default config url found.";
    this._config = options.config.api;
    this.qry = this.query;
    this.mut = this.mutate;
    this._r14 = R14;
    this._qryBatch = {};
    this._qryBatchTimeout = null;
    this._qryBatchTimeouts = {};
    this._qryBatchIdx = 0;
    this._qryBatchTimeoutIdx = 0;
    this._qryBatchTimeoutKey = null;
    this._qryBatchResponses = {};
  }
  async batch(queries, options = {}) {
    if (Array.isArray()) {
      throw new Error("TODO ADD BATCH QURY BY ARR");
    } else if (typeof queries !== "object")
      throw new Error("Api Error: Batch must be given object or array");
    return await this.fetch("/graphql", { queries: queries });
  }
  async autoBatch(query, variables) {
    let batchKey = `qb${++this._qryBatchIdx}`;

    this._qryBatch[batchKey] = { query: query, variables: variables };

    let promise = new Promise((resolve, reject) => {
      this._qryBatchResponses[batchKey] = {
        resolve: resolve,
        reject: reject,
      };
    });
    this.runBatch();
    return promise;
  }
  runBatch() {
    if (!this._qryBatchTimeoutKey)
      this._qryBatchTimeoutKey = `qbt${++this._qryBatchTimeoutIdx}`;
    let qryBatchTimeoutKey = this._qryBatchTimeoutKey;
    if (!this._qryBatchTimeouts[qryBatchTimeoutKey]) {
      this._qryBatchTimeouts[qryBatchTimeoutKey] = setTimeout(async () => {
        this._qryBatchTimeoutKey = null;
        let res = await this.batch(this._qryBatch);
        let resData = res && res.data ? res.data : {};
        for (let k in resData) {
          if (this._qryBatch[k]) delete this._qryBatch[k];
          if (this._qryBatchResponses[k]) {
            this._qryBatchResponses[k].resolve(new R14ApiResult(resData[k]));
            delete this._qryBatchResponses[k];
          }
        }
        //this._qryBatch = {};
        delete this._qryBatchTimeouts[qryBatchTimeoutKey];
      }, 250);
    }
  }
  async query(query, variables = {}) {
    return await this.autoBatch(query, variables);
    // let res = await this.fetch("/graphql", {
    //   query: query,
    //   variables: variables
    // });
    // return new R14ApiResult(res);
  }
  async subscribe(query, variables = {}, callback) {
    let token = await this._getAccessToken();
    
    let subscription = new R14ApiSubscription(this._r14, {
      query: query,
      variables: variables,
      accessToken: token || null,
    }, callback);
    return await subscription.subscribe();

    // let subscriber = new Promise((resolve, reject) => {
    //   this._r14.app.io.emit(
    //     "subscribe",
    //     {
    //       query: query,
    //       variables: variables,
    //       accessToken: token || null,
    //     },
    //     (data) => {
    //       if (data && data.keys) {
    //         for (let i in data.keys) {
    //           this._r14.app.io.on(data.keys[i], (res) => {
    //             callback(new R14ApiResult(res));
    //           });
    //         }
    //       }
    //       resolve(data || null);
    //     }
    //   );
    // });
    // let data = await subscriber;
    // return new R14ApiSubscription(
    //   this._r14,
    //   data && data.keys ? data.keys : null
    // );
  }
  async mutate(mutation, variables = {}) {
    // Check if it is an instance of the formDomain, if so, convert to formData
    // let method = "fetch";
    // if(variables.toFormData) variables = variables.toFormData();

    // let vars = {};
    // for(let i in variables){
    //   // Check if formdata should be converted
    //   vars[i] = variables[i].toFormData ? variables[i].toFormData() : variables[i];

    //   if(vars[i] instanceof FormData){
    //     method = "submit";
    //   }
    // }
    let formData = this.createFormData(mutation, variables);
    let res = await this.fetch("/graphql", formData);
    return new R14ApiResult(res);
  }
  async fetch(namespace, data = {}) {
    let config = {
      headers: {},
    };
    if (await this.hasAccessToken()) {
      config.headers["Authorization"] =
        "Bearer " + (await this._getAccessToken());
    }
    let response = { error: "Unknwon Error." };

    response = await axios.post(this.baseUrl + namespace, data, config);

    // Save the token
    //if (response.data.accessToken) await AsyncStorage.setItem("accessToken", response.data.accessToken);
    return response.data;
  }
  // Post same as fetch
  async post(namespace, data) {
    return await this.fetch(namespace, data);
  }
  createFileMap(variables, map = {}, namespace = "r14.file") {
    if (variables instanceof File) {
      map[namespace] = variables;
      return null;
    } else if (Array.isArray(variables)) {
      variables.forEach((variable, i) => {
        let nNamespace = namespace ? `${namespace}.${i}` : i;
        variables[i] = this.createFileMap(variable, map, nNamespace);
      });
      return variables;
    } else if (typeof variables === "object") {
      for (let k in variables) {
        let nNamespace = namespace ? `${namespace}.${k}` : k;
        variables[k] = this.createFileMap(variables[k], map, nNamespace);
      }
    } else {
      return variables;
    }

    return variables;
  }
  createFormData(query, variables) {
    let fileMap = {};
    // Variables and fileMap will be updated by value in params
    // All files will be set to null in variables
    // fileMap is a map of file namespace path and file
    this.createFileMap(variables, fileMap);

    let formData = new FormData();
    let ret = null;
    if (Object.keys(fileMap).length) {
      formData.append(
        "r14GraphQlQuery",
        JSON.stringify({
          query,
          variables,
        })
      );
      for (let k in fileMap) {
        formData.append(k, fileMap[k]);
      }
      ret = formData;
    } else ret = { query, variables };
    return ret;
  }
  // Can be either formData or FormUiDomain
  async submit(namespace, form) {
    let formData = form instanceof FormData ? form : form.toFormData();

    let config = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };
    if (await this.hasAccessToken())
      config.headers["Authorization"] =
        "Bearer " + (await this._getAccessToken());
    const response = await axios.post(
      this.baseUrl + namespace,
      formData,
      config
    );

    // Save the token
    //if (response.data.accessToken) await AsyncStorage.setItem("accessToken", response.data.accessToken);

    return response.data.data;
  }
  get config() {
    return this._config;
  }
  get baseUrl() {
    return this.config.url;
  }
  async _getAccessToken() {
    return (await AsyncStorage.getItem("accessToken")) || null;
  }
  async setAccessToken(accessToken) {
    await AsyncStorage.setItem("accessToken", accessToken);
    return true;
  }
  async deleteAccessToken() {
    await AsyncStorage.removeItem("accessToken");
    return true;
  }
  async accessTokenExists() {
    return (await AsyncStorage.getItem("accessToken")) ? true : false;
  }
  async hasAccessToken() {
    return await this.accessTokenExists();
  }
}
// class R14ApiResult {
//   constructor(res) {
//     this._metadata = {
//       data: res.data || {},
//       errors: res.errors || [],
//     };
//     return new Proxy(this, {
//       get: (obj, prop) => {
//         if (obj[prop]) return obj[prop];
//         if (prop === "then") return undefined;
//         else {
//           console.warn(
//             `R14Api Warning: Accessing data '${prop}' directly from the result is being depreciated. Please use the data / error properties.`
//           );
//           return obj.data[prop];
//         }
//       },
//       set: (obj, prop, val) => {
//         console.warn("R14Api Warning: Cannot set api result values.");
//       },
//     });
//   }
//   toString() {
//     return this._metadata.toString();
//   }
//   get data() {
//     return this._metadata.data;
//   }
//   get errors() {
//     return this._metadata.errors;
//   }
// }
